import PropTypes from 'prop-types'
import { ExclamationMark, WarningDiamond, Info } from '@phosphor-icons/react'

export const Priority = ({ value }) => {
  const highPriorityObject = {
    icon: <WarningDiamond className="high" size={20} />,
    className: 'high',
  }

  const priorityConfig = {
    Routine: {
      icon: <Info size={20} />,
      className: 'routine',
    },
    Low: {
      icon: <Info size={20} />,
      className: 'low',
    },
    Med: {
      icon: <ExclamationMark size={20} />,
      className: 'med',
    },
    High: highPriorityObject,
    Critical: highPriorityObject,
    Emergency: highPriorityObject,
  }

  const { className, icon } = priorityConfig[value] || {}

  return (
    <div className={`priority ${className}`}>
      {icon}
      {value}
    </div>
  )
}

Priority.propTypes = {
  value: PropTypes.string,
}

export default Priority
